export default __webpack_public_path__ + "static/media/abOntimeLogoPreto.41694eb1.png";